import React  from "react";
import Polyglot from "node-polyglot";
import egumaReact from "egumaReact"; // added in externals in webpack
const polyglot = new Polyglot({ phrases: egumaReact.translations });

function Tickets({ handleChange, selectedTickets, tickets }) {
  if (tickets.length === 0) {
    return null;
  }

  return (
      <table className="table" style={{ marginTop: 20 }}>
        <thead>
          <tr style={{ height: 25 }}>
            <th>
              <strong>
                <span id="event-details-ticket-type-title">
                  {polyglot.t("Common.Category")}
                </span>
              </strong>
            </th>
            <th style={{ textAlign: "right", minWidth: 126 }}>
              <span className="event-details-price">
                <strong>{polyglot.t("Common.Price")}</strong>
                <span style={{ fontSize: "0.7em" }}>
                  {" "}
                  {polyglot.t("Bill.VatIncluded")}
                </span>
              </span>
            </th>
            <th style={{ textAlign: "right" }}>
              <strong>{polyglot.t("Common.Quantity")}</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket) => (
            <tr key={ticket.id} style={{ height: 45 }}>
              <td>
                <div dangerouslySetInnerHTML={{ __html: ticket.name }} />
                <div
                  id="ticket-type-description"
                  style={{
                    marginTop: 4,
                    fontSize: "0.8em"
                  }}
                  dangerouslySetInnerHTML={{ __html: ticket.description }}
                />
              </td>

              <td className="text-right text-nowrap">
                <span className="event-details-price">
                  {ticket.priceFormatted}
                </span>
              </td>

              <td className="text-right">
                {ticket.isSoldOut ? (
                  <span style={{ color: "#da3856" }}>
                    <strong>{polyglot.t("Common.SoldOut")}</strong>
                  </span>
                ) : (
                  <select
                    id={ticket.id}
                    name={ticket.nameForSelectTag}
                    onChange={(e) => handleChange(ticket.id, e.target.value)}
                    style={{ height: 34, width: "auto", minWidth: 53 }}
                    value={selectedTickets[ticket.id]}
                  >
                    {ticket.quantities.map((qty) => (
                      <option key={"ticket_option_" + qty} value={qty}>
                        {qty}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
  );
}

export default Tickets;
